import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../styles/animations/lf30_editor_lkoftv7f.json'
import '../styles/_loading.scss';

const Loading = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="loading-screen">
      <Lottie options={defaultOptions}
        height={300}
        width={300} />
      <p>loading Quik Quality data ...</p>
    </div>
  )
}

export default Loading;